<script>
// メッセージ(固定値)を記載する
export default {
  // エラーメッセージ
  MSG_COM_0001: '入力は必須です。',
  MSG_E001_0001: '認証に失敗しました。',
  MSG_E002_0001: '8文字から30文字で入力してください。',
  MSG_E002_0002: 'Passwordが一致しません。',
  MSG_E002_0003: 'Passwordに使用可能な文字は半角英数字および#$+-./:=?@[]^_`|です。',
  MSG_E002_0004: 'Passwordは半角英大文字、小文字、数字、使用可能な記号( #$+-./:=?@[]^_`| )からそれぞれ1文字以上使用する必要があります。',
  MSG_E002_0005: 'このアクセス元からのアクセスは一時的に制限されています。',
  MSG_E002_0006: 'このアカウントに対するログイン試行は制限されています。',
  MSG_E002_0007: '必須項目が入力されていません。',
  MSG_E002_0008: '入力内容に間違いがあります。',

  // ダイアログ等メッセージ
  MSG_SES_CANNOT_CONFIRM: 'セッションタイムアウト\nセッションが確認できませんでした。\nログイン画面に戻ります。',
  MSG_CREATE_FORM_LEAVE: '登録確認\n登録を破棄し、別の画面に移動します。\nよろしいですか？',
  MSG_FORM_INVALID: '必須項目が入力されていません。\n内容を確認してください。',
  MSG_FORM_SUBMIT_ERROR: 'サーバーエラー\n登録が完了できませんでした。\n登録内容の確認、もしくは管理者にお問い合わせください。',
  MSG_CONNETION_ERROR: '接続がタイムアウトしました'
}

</script>



// WEBPACK FOOTER //
// src/components/modules/MsgList.vue